import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({
              providedIn: 'root'
            })
export class AgendaSubjectEventService {

  onChangeEvents: Subject<void> = new Subject<void>();

}
